export function nippleMovementData(event, legacyData = null) {
    return event?.data || legacyData || null;
}
